import { Component, Input, OnInit } from '@angular/core';
import { ApplicationEntityModel, CandidateEntityModel, JobOffer } from 'app/interfaces';
import { JobOffersService } from 'app/services';

@Component({
  selector: 'app-candidate-comments',
  templateUrl: './candidate-comments.component.html',
  styleUrls: ['./candidate-comments.component.scss']
})
export class CandidateCommentsComponent implements OnInit {
  @Input() candidate: CandidateEntityModel = null;
  @Input() jo: JobOffer = null;

  public applications: ApplicationEntityModel[] = [];
  constructor(
    private jobOffersService: JobOffersService
  ) {

  }

  async ngOnInit() {
    const applications = await this.jobOffersService.getAllApplications(Number(this.candidate.User.id)).toPromise();
    this.applications = applications.reverse().filter(a => a.job_offers_id !== this.candidate.job_offers_id);
  }

}
